/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtract`)
};

const es_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restar`)
};

const de_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrahieren`)
};

const nl_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aftrekken`)
};

const fr_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soustraire`)
};

const it_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottrai`)
};

const pt_br2_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrair`)
};

const pt_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtrair`)
};

const ja_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引き算`)
};

const zh_fr_subtract = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_subtract = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_subtract(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_subtract", locale)
	if (locale === "en") return en_fr_subtract(inputs)
	if (locale === "es") return es_fr_subtract(inputs)
	if (locale === "de") return de_fr_subtract(inputs)
	if (locale === "nl") return nl_fr_subtract(inputs)
	if (locale === "fr") return fr_fr_subtract(inputs)
	if (locale === "it") return it_fr_subtract(inputs)
	if (locale === "pt-BR") return pt_br2_fr_subtract(inputs)
	if (locale === "pt") return pt_fr_subtract(inputs)
	if (locale === "ja") return ja_fr_subtract(inputs)
	return zh_fr_subtract(inputs)
};